import {AfterViewInit, ChangeDetectorRef, Component, HostListener, Injector, OnDestroy, OnInit,} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {strings} from '../../../../value/strings';
import {DataResponse} from '../../../network/service/data.response';
import {SessionStorageUtil} from '../../../util/session.storage.util';
import {isEqual} from 'lodash';
import {Config} from '../../../common/config';
import {DeviceService} from '../../../util/service/device.service';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {FactorStatusHelper} from '../../../enums/factor.status';
import {Params} from '@angular/router';
import {RouteUtil} from '../../../util/route.util';

@Component({
  selector: 'app-menu',
  standalone: false,
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedUniqueIdentifier?: string;
  selectedIndex: number = 0;
  selectedCategoryId?: string;
  selectedServicePriceId?: string;
  selectedTagId?: string;
  orders?: any;
  categoryAndTags: any = [];
  services: any = [];
  allServices: any = [];
  isCategoriesLoading: boolean = true;
  isServicesLoading: boolean = true;
  isSticky: boolean = false;
  isMobile?: boolean;
  searchControl = new FormControl('');
  isSearching: boolean = false;
  searchResults: any = [];
  showSearchResults: boolean = false;
  highlightedCategories: Set<string> = new Set();
  highlightedTags: Set<string> = new Set();
  originalSelectedIndex: number = 0;
  originalSelectedTagId?: any;
  originalSelectedCategoryId?: any;
  hasStoredOriginal: boolean = false;
  urlParamsProcessed: boolean = false;
  activeOrders: any[] = [];
  isActiveOrdersLoading: boolean = false;
  activeOrdersSkeletonPlaceholders: number[] = Array.from({length: 1}, (_, index) => index);
  activeOrdersSkeletonProductPlaceholders: number[] = Array.from({length: 3}, (_, index) => index);
  skeletonPlaceholders: number[] = Array.from({length: 10}, (_, index) => index);
  categorySkeletonPlaceholders: number[] = Array.from({length: 15}, (_, index) => index);
  // برای تست: true کن تا اسکلتون همیشه نمایش داده شود
  testSkeletonMode: boolean = false;
  private activeOrdersInterval?: any;

  constructor(injector: Injector, private cdr: ChangeDetectorRef, deviceService: DeviceService) {
    super(injector);
    this.isMobile = deviceService.isMobile();
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['CategoryOrTagSlug'] && params['CategoryOrTagSlug'] !== '') {
        this.selectedUniqueIdentifier = params['CategoryOrTagSlug'];
      }
    });
  }

  override ngOnInit() {
    super.ngOnInit();
    this.setupSearch();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getCategoryAndTags(undefined, undefined, undefined, RequestType.ALL, Config.branch.BusinessId, {
      Order: {
        Field: 'Order',
        Type: 'ASC'
      }
    }).subscribe({
      next: (res: ListResponse<any>) => {
        if (res.success) {
          this.categoryAndTags = res.data!;
          let selectedTagIndex = this.categoryAndTags.Tags.findIndex((tag: any) => {
            return tag.UniqueIdentifier === this.selectedUniqueIdentifier;
          });
          let selectedCategoryIndex = this.categoryAndTags.Categories.findIndex((category: any) => {
            return category.UniqueIdentifier === this.selectedUniqueIdentifier;
          });
          if (selectedTagIndex && selectedTagIndex !== -1) {
            this.selectedTagId = this.categoryAndTags.Tags[selectedTagIndex].TagId;
            this.selectedIndex = selectedTagIndex;
          }
          if (selectedCategoryIndex && selectedCategoryIndex !== -1) {
            this.selectedCategoryId = this.categoryAndTags.Categories[selectedCategoryIndex].CategoryId;
            this.selectedIndex = selectedTagIndex + (this.categoryAndTags.Tags ?? []).length;
          }
          if (!this.selectedTagId && !this.selectedCategoryId) {
            if (this.categoryAndTags.Tags.length > 0) {
              this.selectedTagId = this.categoryAndTags.Tags[0].TagId;
              this.selectedUniqueIdentifier = this.categoryAndTags.Tags[0].UniqueIdentifier;
            } else if (this.categoryAndTags.Categories.length > 0) {
              this.selectedCategoryId = this.categoryAndTags.Categories[0].CategoryId;
              this.selectedUniqueIdentifier = this.categoryAndTags.Categories[0].UniqueIdentifier;
            }
            this.updateUrlWithSelection(this.selectedUniqueIdentifier ?? '');
          }
          setTimeout(() => {
            this.storeOriginalSelection();
          }, 0);
          this.loadAllProducts();
          this.loadActiveOrder();
          if (!this.testSkeletonMode) {
            this.isCategoriesLoading = false;
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          if (!this.testSkeletonMode) {
            this.isCategoriesLoading = false;
            this.isServicesLoading = false;
          }
        }
      },
      error: (error) => {
        SnackBarUtil.makeMessage(this, this.translateService.instant('FailedToLoadCategories'), false);
        if (!this.testSkeletonMode) {
          this.isCategoriesLoading = false;
          this.isServicesLoading = false;
        }
      }
    });
  }

  loadAllProducts() {
    this.isServicesLoading = true;
    this.services = [];
    const filter: any = {
      Values: []
    };
    if (this.selectedTagId) {
      filter.Values.push({
        Field: 'TagId',
        Type: 'EQ',
        Value: this.selectedTagId
      });
    } else if (this.selectedCategoryId) {
      filter.Values.push({
        Field: 'CategoryId',
        Type: 'EQ',
        Value: this.selectedCategoryId
      });
    }
    this.serviceApi.getServices(undefined, undefined, 'ServicePrices,ServicePrices.ServicePriceAdditives,ServicePrices.ServicePriceAdditives.Additive,ServicePrices.ServicePriceAdditives.Attribute,ServicePrices.ServicePriceAdditives.Attribute.AttributeType,Category,Tag', RequestType.ALL, Config.branch.BusinessId, {
      Filter: filter
    }).subscribe({
      next: (res: ListResponse<any>) => {
        if (res.success) {
          this.services = res.data!;
          this.allServices = [...res.data!];
          for (let i = 0; i < this.services.length; i++) {
            if (this.services[i].ServicePrices?.length > 0) {
              this.selectedServicePriceId = this.services[i].ServicePrices[0].ServicePriceId;
            }
          }
          this.getOrders();
          this.cdr.detectChanges();
          if (!this.testSkeletonMode) {
            this.isServicesLoading = false;
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          if (!this.testSkeletonMode) {
            this.isServicesLoading = false;
          }
        }
      },
      error: () => {
        if (!this.testSkeletonMode) {
          this.isServicesLoading = false;
        }
      }
    });
  }

  setupSearch() {
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      if (searchTerm && searchTerm.trim().length > 0) {
        this.performSearch(searchTerm.trim());
      } else {
        this.clearSearch();
      }
    });
  }

  performSearch(searchTerm: string) {
    this.storeOriginalSelection();
    this.isSearching = true;
    this.showSearchResults = true;
    this.isServicesLoading = true;
    this.services = [];
    const searchFilter = {
      Values: [{
        Field: 'Title',
        Type: 'LIKE',
        Value: '%' + searchTerm + '%'
      }]
    };
    this.serviceApi.getServices(undefined, undefined, 'ServicePrices,ServicePrices.ServicePriceAdditives,ServicePrices.ServicePriceAdditives.Additive,ServicePrices.ServicePriceAdditives.Attribute,ServicePrices.ServicePriceAdditives.Attribute.AttributeType,Category,Tag', RequestType.ALL, Config.branch.BusinessId, {
      Filter: searchFilter
    }).subscribe({
      next: (res: ListResponse<any>) => {
        if (res.success) {
          this.searchResults = res.data!;
          this.services = res.data!;
          this.updateHighlightedCategories();
          this.cdr.detectChanges();
          if (!this.testSkeletonMode) {
            this.isServicesLoading = false;
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          if (!this.testSkeletonMode) {
            this.isServicesLoading = false;
          }
        }
        this.isSearching = false;
      },
      error: (error) => {
        SnackBarUtil.makeMessage(this, this.translateService.instant('FailedToSearch'), false);
        this.isSearching = false;
        if (!this.testSkeletonMode) {
          this.isServicesLoading = false;
        }
      }
    });
  }

  updateHighlightedCategories() {
    this.highlightedCategories.clear();
    this.highlightedTags.clear();
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.forEach((service: any) => {
        if (service.Category && service.Category.CategoryId) {
          this.highlightedCategories.add(service.Category.CategoryId);
        }
        if (service.Tag && service.Tag.TagId) {
          this.highlightedTags.add(service.Tag.TagId);
        }
      });
      if (this.highlightedCategories.size === 0 && this.highlightedTags.size === 0) {
        this.findCategoriesFromAllServices();
      }
      this.autoSelectHighlightedCategory();
    }
  }

  autoSelectHighlightedCategory() {
    if (this.highlightedTags.size > 0) {
      const firstTagId = Array.from(this.highlightedTags)[0];
      const tagIndex = this.categoryAndTags.Tags?.findIndex((tag: any) => tag.TagId === firstTagId);
      if (tagIndex !== -1) {
        this.selectedIndex = tagIndex;
        this.selectedTagId = firstTagId;
        this.selectedCategoryId = undefined;
        this.scrollToCategory(tagIndex, 'tag');
        return;
      }
    }
    if (this.highlightedCategories.size > 0) {
      const firstCategoryId = Array.from(this.highlightedCategories)[0];
      const categoryIndex = this.categoryAndTags.Categories?.findIndex((category: any) => category.CategoryId === firstCategoryId);
      if (categoryIndex !== -1) {
        this.selectedIndex = categoryIndex + (this.categoryAndTags.Tags?.length || 0);
        this.selectedCategoryId = firstCategoryId;
        this.selectedTagId = undefined;
        this.scrollToCategory(categoryIndex, 'category');
        return;
      }
    }
  }

  scrollToCategory(index: number, type: 'tag' | 'category') {
    setTimeout(() => {
      const scrollContainer = document.querySelector('.scroll-content');
      if (scrollContainer) {
        const categoryElements = scrollContainer.querySelectorAll('.card-dessert');
        let targetElement: Element | null = null;
        if (type === 'tag') {
          targetElement = categoryElements[index];
        } else {
          const tagCount = this.categoryAndTags.Tags?.length || 0;
          targetElement = categoryElements[index + tagCount];
        }
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          });
        }
      }
    }, 100);
  }

  findCategoriesFromAllServices() {
    if (this.allServices && this.allServices.length > 0) {
      this.searchResults.forEach((searchService: any) => {
        const matchingService = this.allServices.find((service: any) =>
          service.ServiceId === searchService.ServiceId ||
          service.Title === searchService.Title
        );
        if (matchingService) {
          if (matchingService.Category && matchingService.Category.CategoryId) {
            this.highlightedCategories.add(matchingService.Category.CategoryId);
          }
          if (matchingService.Tag && matchingService.Tag.TagId) {
            this.highlightedTags.add(matchingService.Tag.TagId);
          }
        }
      });
    }
  }

  clearSearch() {
    this.searchControl.setValue('');
    this.showSearchResults = false;
    this.searchResults = [];
    this.highlightedCategories.clear();
    this.highlightedTags.clear();
    if (this.allServices && this.allServices.length > 0) {
      this.services = [...this.allServices];
    }
    this.restoreOriginalSelection();
    this.isServicesLoading = false;
    this.cdr.detectChanges();
  }

  clearSearchOnly() {
    this.searchControl.setValue('');
    this.showSearchResults = false;
    this.searchResults = [];
    this.highlightedCategories.clear();
    this.highlightedTags.clear();
    if (this.allServices && this.allServices.length > 0) {
      this.services = [...this.allServices];
    }
    this.isServicesLoading = false;
    this.cdr.detectChanges();
  }

  restoreOriginalSelection() {
    this.selectedIndex = this.originalSelectedIndex;
    this.selectedTagId = this.originalSelectedTagId;
    this.selectedCategoryId = this.originalSelectedCategoryId;
    if (this.selectedTagId || this.selectedCategoryId) {
      this.loadAllProducts();
    }
    this.cdr.detectChanges();
  }

  storeOriginalSelection() {
    if (!this.hasStoredOriginal) {
      this.originalSelectedIndex = this.selectedIndex;
      this.originalSelectedTagId = this.selectedTagId;
      this.originalSelectedCategoryId = this.selectedCategoryId;
      this.hasStoredOriginal = true;
    }
  }

  getGroupedSearchResults() {
    if (!this.searchResults || this.searchResults.length === 0) {
      return [];
    }
    const grouped: any = {};
    this.searchResults.forEach((service: any) => {
      let categoryName = '';
      if (service.Category) {
        categoryName = service.Category.Title;
      } else if (service.Tag) {
        categoryName = service.Tag.Title;
      } else {
        categoryName = this.translateService.instant('Other');
      }
      if (!grouped[categoryName]) {
        grouped[categoryName] = [];
      }
      grouped[categoryName].push(service);
    });
    return Object.keys(grouped).map(categoryName => ({
      categoryName: categoryName,
      services: grouped[categoryName]
    }));
  }

  onTagClick(tag: any): void {
    this.urlParamsProcessed = false;
    this.selectedUniqueIdentifier = tag.UniqueIdentifier;
    this.selectedTagId = tag.TagId;
    this.selectedCategoryId = undefined;
    if (this.showSearchResults) {
      this.clearSearchOnly();
    }
    this.updateUrlWithSelection(tag.UniqueIdentifier);
    this.loadAllProducts();
    setTimeout(() => {
      this.scrollToTop();
    }, 100);
  }

  onCategoryClick(category: any): void {
    this.urlParamsProcessed = false;
    this.selectedUniqueIdentifier = category.UniqueIdentifier;
    this.selectedCategoryId = category.CategoryId;
    this.selectedTagId = undefined;
    if (this.showSearchResults) {
      this.clearSearchOnly();
    }
    this.updateUrlWithSelection(category.UniqueIdentifier);
    this.loadAllProducts();
    setTimeout(() => {
      this.scrollToTop();
    }, 100);
  }

  getSelectedTitle(): string {
    if (this.selectedTagId) {
      const selectedTag = this.categoryAndTags.Tags.find((tag: any) => tag.TagId === this.selectedTagId);
      return selectedTag ? selectedTag.Title : '';
    } else if (this.selectedCategoryId) {
      const selectedCategory = this.categoryAndTags.Categories.find((category: any) => category.CategoryId === this.selectedCategoryId);
      return selectedCategory ? selectedCategory.Title : '';
    }
    return '';
  }

  getOrders() {
    if (this.hasAccount()) {
      this.serviceApi.getMyOrders(undefined, undefined, 'ServicePrice,ServicePrice.Service,ServicePrice.Service.ServicePrices,ServicePrice.ServicePriceAdditives,ServicePrice.ServicePriceAdditives.Additive,ServicePrice.ServicePriceAdditives.Attribute,OrderServicePriceAdditives,OrderServicePriceAdditives.ServicePriceAdditive,OrderServicePriceAdditives.ServicePriceAdditive.Additive,OrderServicePriceAdditives.ServicePriceAdditive.Attribute,OrderServicePriceAdditives.ServicePriceAdditive.Attribute.AttributeType', RequestType.ALL, Config.branch.BusinessId, {
        Filter: {
          Values: [{
            Field: 'Type',
            Type: 'EQ',
            Value: strings.basket,
          }]
        }
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          this.orders = res.data?.map((order: any) => {
            // Extract ServicePriceAdditiveIds from OrderServicePriceAdditives if not already set
            if (!order.ServicePriceAdditiveIds && order.OrderServicePriceAdditives?.length > 0) {
              order.ServicePriceAdditiveIds = order.OrderServicePriceAdditives.map((osa: any) =>
                osa.ServicePriceAdditive?.ServicePriceAdditiveId
              ).filter((id: any) => id != null);
            }
            return order;
          });
          this.cdr.detectChanges();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    } else {
      let basket: any[] = SessionStorageUtil.loadObject(strings.basket_service_ids, []);
      this.orders = basket;
      Config.basketCount = basket.length;
      this.cdr.detectChanges();
    }
  }

  onServiceClicked(object: any) {
    if (object.Service.ServicePrices?.length > 0 && object.Service.ServicePrices[0].ServicePriceAdditives?.length > 0) {
      this.saveOrder(object, object.Service, object.Service.ServicePriceAdditiveIds);
    } else {
      this.saveOrder(object, object.Service);
    }
  }

  saveOrder(object: any, service: any, additives?: any[]) {
    if (this.hasAccount()) {
      this.serviceApi.postOrders({
        ServicePriceId: service.ServicePrices[0]?.ServicePriceId,
        Count: object.Count,
        Type: strings.basket,
        ServicePriceAdditiveIds: additives,
        BranchId: Config.branch.BusinessId
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          if (res.data.dataValues && !res.data.previousDataValues) {
            Config.basketCount++;
          } else if (!res.data.dataValues) {
            Config.basketCount--;
          }
          this.getOrders();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    } else {
      let basket: any[] = SessionStorageUtil.loadObject(strings.basket_service_ids, []);
      let basketServicePrice: any;
      if (additives) {
        basketServicePrice = basket.find((basketServicePrice: any) => {
          return service.ServicePrices[0].ServicePriceId === basketServicePrice.ServicePriceId &&
            isEqual(basketServicePrice.ServicePriceAdditiveIds, additives);
        });
      } else {
        basketServicePrice = basket.find((basketServicePrice: any) => {
          return service.ServicePrices[0].ServicePriceId === basketServicePrice.ServicePriceId;
        });
      }
      if (basketServicePrice) {
        basketServicePrice.Count = object.Count;
      } else {
        let temp = {
          ...service.ServicePrices[0]
        };
        temp.ServicePrice = service.ServicePrices[0];
        temp.ServicePrice.Service = {...object.Service};
        delete temp.ServicePrice.Service.ServicePrices;
        temp.Count = object.Count;
        temp.ServicePriceAdditiveIds = service.ServicePriceAdditiveIds;
        basket.push(temp);
      }
      basket = basket.filter((basketServicePrice: any) => {
        return basketServicePrice.Count !== 0;
      });
      SessionStorageUtil.saveObject(strings.basket_service_ids, basket);
      this.getOrders();
      Config.basketCount = basket.length;
    }
  }

  updateUrlWithSelection(slug: string): void {
    this.router.navigate([RouteUtil.MENU_COMPONENT, Config.branch.UniqueIdentifier, slug], {
      replaceUrl: true
    }).then();
  }

  loadActiveOrder() {
    const hasExistingActiveOrders = (this.activeOrders?.length ?? 0) > 0;
    this.isActiveOrdersLoading = hasExistingActiveOrders;
    if (this.hasAccount()) {
      this.serviceApi.getMyFactors(this.tableProperties.offset, undefined, 'Business,FactorOrders,FactorOrders.Order,FactorOrders.Order.ServicePrice,FactorOrders.Order.ServicePrice.Service,FactorOrders.Order.ServicePrice.Service.Images,Metadata', RequestType.ALL, {
        Filter: {
          Values: [
            {
              Field: 'OpenFactors',
              Type: 'EQ',
              Value: true
            }
          ]
        },
        Order: {
          Field: 'CreateDate',
          Type: 'DESC'
        }
      }, Config.branch.BusinessId).subscribe({
        next: (res: ListResponse<any>) => {
          if (res.success && res.data && res.data.length > 0) {
            this.activeOrders = res.data;
            this.cdr.detectChanges();
            this.startActiveOrdersRefresh();
          } else {
            this.activeOrders = [];
            this.stopActiveOrdersRefresh();
          }
          this.isActiveOrdersLoading = false;
        },
        error: () => {
          this.activeOrders = [];
          this.isActiveOrdersLoading = false;
          this.stopActiveOrdersRefresh();
        }
      });
    } else {
      this.activeOrders = [];
      this.isActiveOrdersLoading = false;
      this.stopActiveOrdersRefresh();
    }
  }

  startActiveOrdersRefresh() {
    this.stopActiveOrdersRefresh();
    this.activeOrdersInterval = setInterval(() => {
      this.loadActiveOrder();
    }, 60000);
  }

  stopActiveOrdersRefresh() {
    if (this.activeOrdersInterval) {
      clearInterval(this.activeOrdersInterval);
      this.activeOrdersInterval = undefined;
    }
  }

  ngOnDestroy() {
    this.stopActiveOrdersRefresh();
  }

  deliveryTime(factor: any): string {
    const timestamp = factor?.Metadata?.RemainedTimeToDeliver;
    if (!timestamp) return '-';
    const date = new Date(Number(timestamp));
    const utc = date.getTime() + (date.getTimezoneOffset() * 60000);
    const tehranTime = new Date(utc + (3.5 * 60 * 60 * 1000));
    const hours = tehranTime.getHours().toString().padStart(2, '0');
    const minutes = tehranTime.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  getOrderStatusText(status: string): string {
    const statusKey = FactorStatusHelper.getStatusText(status);
    return this.translateService.instant(statusKey);
  }

  override onImageError(event: any) {
    if (event.target) {
      event.target.src = '/icons/image-placeholder.svg';
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollThreshold = 57;
    this.isSticky = window.scrollY >= scrollThreshold;
  }

  private scrollToTop(): void {
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
    const container = document.querySelector('.mobile-container');
    if (container) {
      container.scrollTop = 0;
    }
  }
}
